import { useEffect, useState } from "react";
import PageHeader from "../shared/pageHeader/PageHeader";
import Footer from "../shared/Footer";
import Header from "../shared/header/Header";
import NavigationMenu from "../shared/navigationMenu/NavigationMenu";
import StudentHeader from "./StudentHeader";

import { fetchData } from "../../utils/options";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import StudentRenewal from "./StudentRenewal";
const RenewalList = () => {
  const navigate = useNavigate();
  const [students, setStudents] = useState([]);

  const [allStudents, setAllStudents] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (!localStorage.getItem("access_token")) navigate("/");
  }, []);

  useEffect(() => {
    loadAllStudents();
  }, []);

  const loadAllStudents = async () => {
    try {
      Swal.fire({
        title: "loading",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const result = await fetchData("subscription-payout-list", {}, "GET");
      if (result) {
        setStudents(result.data);
        setAllStudents(result.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      Swal.close();
    }
  };

  // When filter sends result
const handleFiltered = (filteredData) => {
  if (!filteredData || filteredData.length === 0) {
    setStudents(allStudents);
    return;
  }

  const filteredStudentIds = filteredData.map((s) => s.id);

  const matchedRenewals = allStudents.filter((s) =>
    filteredStudentIds.includes(s.student_id)
  );

  setStudents(matchedRenewals);
};


  return (
    <>
      <Header />
      <NavigationMenu />
      <main className="nxl-container">
        <div className="nxl-content">
          <PageHeader>
            <StudentHeader onFiltered={handleFiltered} />
          </PageHeader>
          <div className="main-content">
            <div className="row">
              <StudentRenewal students={students} />
            </div>
          </div>
          <Footer />
        </div>
      </main>
    </>
  );
};

export default RenewalList;
